(ns app.front.view.public-notice.public-link
  (:require ["@carbon/icons-react/es/copy--link/32" :default CopyLink32]
            [app.front.clipboard :as clipboard]
            [app.front.process :as process]
            [app.front.ui.error-list :as ui-error-list]
            [app.front.view.workspace.subs :as ws-subs]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.href :as href]
            [core.front.icons :as i]
            [re-frame.core-instrumented :as rf]))


(rf/reg-event-fx ::toggle-published
  (fn [_ [_ value fsm-target tr]]
    {:dispatch (if value
                 [:app.front.process/signal
                  fsm-target
                  [:process.signal/publish-public-notice]
                  {:notify {:success (tr [:public-notice/link-published])}}]
                 [:app.front.process/signal
                  fsm-target
                  [:process.signal/unpublish-public-notice]
                  {:notify {:success (tr [:public-notice/link-unpublished])}}])}))


(rf/reg-sub ::public-link-visible?
  (fn [[_ target-id] _]
    (rf/subscribe [::process/signal-forbidden? target-id [:process.signal/publish-public-notice]]))
  :-> not)


(rf/reg-sub ::publishing-errors
  (fn [[_ fsm-target] _]
    (rf/subscribe [::process/signal-errors-for-error-list fsm-target [:process.signal/publish-public-notice]]))
  (fn [errors _]
    errors))


(defn qr-code-link [workspace-id]
  (str "/api/command/qr-code-for-public-notice/" workspace-id))


(defn public-link-wrapper [fsm-target workspace-id url]
  (let [tr            (<sub [:tr])
        published?    (true? (<sub [::ws-subs/public-notice-published?]))
        signal-errors (<sub [::publishing-errors fsm-target])
        unpublishable (some? signal-errors)]
    [:div.mb-4.p-4.bg-ui-light-gray
     [:div.flex.flex-col
      [:h3.uppercase.flex.text-base.font-semibold.mb-0 (tr [:public-notice/publish-link])]
      (when signal-errors
        [:div.mt-4
         [ui-error-list/signal-error-list tr signal-errors]])
      [:div.flex.pt-4.pl-2.justify-start
       (cc/toggle {:id        "publish-public-notice"
                   :labelA    (tr [:public-notice/not-published])
                   :labelB    (tr [:public-notice/published])
                   :toggled   published?
                   :disabled  (and (not published?) unpublishable)
                   :on-toggle (fn [value] (>evt [::toggle-published value fsm-target tr]))})]
      [:div.flex.flex-col.lg:flex-row.pt-4.justify-start
       (cc/button {:id         "copy-public-notice-link"
                   :disabled   (or (not published?) unpublishable)
                   :kind       :tertiary
                   :icon       CopyLink32
                   :size       :small
                   :on-click   #(do
                                  (clipboard/copy-text url)
                                  (>evt [:notifications/add
                                         :toast
                                         :success
                                         (tr [:success])
                                         (tr [:public-notice/url-copied])]))
                   :class-name "m-2"}
                  (tr [:public-notice/copy-link]))
       (cc/button {:id         "download-public-notice-qr-code"
                   :disabled   (or (not published?) unpublishable)
                   :kind       :tertiary
                   :icon       i/download
                   :size       :small
                   :href       (qr-code-link workspace-id)
                   :download   workspace-id
                   :class-name "m-2"}
                  (tr [:public-notice/download-qr-code]))]
      [:div.flex.mt-4.ml-2.justify-start
       (if published?
         [:h4 [:a {:href       (href/href :view/public-notice {:workspace-id workspace-id})
                   :class-name "text-ui-night-sky-100"} url]]
         [:h4 (tr [:public-notice/generate-link])])]
      [:div.flex.py-4.ml-2.justify-start
       (when published?
         [:img {:style {:width "115px"}
                :src   (qr-code-link workspace-id)
                :alt   (tr [:public-notice/qr-code-description])}])]]]))


(defn section [fsm-target workspace-id]
  (when (<sub [::public-link-visible? (:db/id fsm-target)])
    (let [url (str js/window.location.protocol "//" js/window.location.hostname
                   (when (not (str/blank? js/window.location.port)) (str ":" js/window.location.port))
                   (href/href :view/public-notice {:workspace-id workspace-id}))]
      [public-link-wrapper fsm-target workspace-id url])))
